<template>
	<div>
		<div class="body">
			<div class="body-container">
				<div class="search-area">
					<div class="search-left-ctr">
						<el-carousel :interval="2000" v-if="publishData && publishData.imageData"
							class="publish-carousel">
							<el-carousel-item v-for="(item, index) in publishData.imageData.list" :key="index">
								<img :src="item.images" @click="clickRoute(item)">
							</el-carousel-item>
						</el-carousel>
					</div>

					<div class="search-box">
						<div class="search-row">
							<div class="search-label">学校级别：</div>
							<div>
								<span class="search-value" v-for="(item, index) in levelList" :key="index"
									:class="{'active-search-value': activeLevel == index}"
									@click="changeLevel(index)">{{ item.name }}</span>
							</div>
						</div>
						<div class="search-row">
							<div class="search-label">报告内容：</div>
							<div>
								<span class="search-value" v-for="(item, index) in contentTypeList" :key="index"
									:class="{'active-search-value': activeContentType == index}"
									@click="changeContentType(index)">{{ item.name }}</span>
							</div>
						</div>
						<div class="search-row" v-if="activeContentType == 0">
							<div class="search-label">排名类型：</div>
							<div>
								<span class="search-value" v-for="(item, index) in rankTypeList" :key="index"
									:class="{'active-search-value': activeRankType == index}"
									@click="changeRankType(index)">{{ item.name }}</span>


								<label v-if="rankTypeList && rankTypeList.length > 0 
                    && rankTypeList[activeRankType].value == 'province_rank'" class="province-span">
									<el-select v-model="province_code" filterable remote reserve-keyword
										placeholder="请输入地区名字" :remote-method="loadProvince" @change="changeProvince">
										<el-option v-for="item in searchProvinceList" :key="item.province_code"
											:label="item.province_name" :value="item.province_code">
										</el-option>
									</el-select>
								</label>
							</div>
						</div>
						<div class="search-row" v-if="activeContentType == 1">
							<div class="search-label">报告类型：</div>
							<div>
								<span class="search-value" v-for="(item, index) in reportTypeList" :key="index"
									:class="{'active-search-value': activeReportType == index}"
									@click="changeReportType(index)">{{ item.name }}</span>
							</div>
						</div>

						<div class="search-row">
							<div class="search-label">整体分项：</div>
							<div>
								<span v-for="(item, index) in allPartList" class="search-value" :key="index"
									:class="{'active-search-value': activeAllPart == index}"
									@click="changeAllPart(index)">{{ item.name }}</span>
							</div>
						</div>
						<div v-if="activeAllPart == 1" class="search-row">
							<div class="search-label">具体分项：</div>
							<div>
								<template v-for="(item, index) in partList">
									<span class="search-value" :key="index"
										v-if="levelList[activeLevel]['name'] != '高职' || (levelList[activeLevel]['name'] == '高职' && item['value'] != 'satisfy')"
										:class="{'active-search-value': activePart == index}"
										@click="changePart(index)">{{ item.name }}</span>
								</template>
							</div>
						</div>
						<div class="search-row">
							<div class="search-label">年度：</div>
							<div>
								<span class="search-value" v-for="(item, index) in yearList" :key="index"
									:class="{'active-search-value': activeYear == index}"
									@click="selectSearchValue(index)">{{ item.name }}</span>
							</div>
						</div>
					</div>

					<div class="search-right-ctr">
						<div class="search-title">学校排名查询</div>
						
						<el-select v-model="collegeName" filterable remote reserve-keyword placeholder="请输入学校名字" :remote-method="loadRankColleges" @change="changeCollege" class="search-input">
							<el-option v-for="item in searchCollegeList" :key="item.id" :label="item.name" :value="item.id"></el-option>
						</el-select>

						<div class="search-footer" align='center'>
							<el-button type="primary" size="medium" @click="confirmQueryCollegeRank">确 定</el-button>
						</div>
					</div>
				</div>

				<div class="content-area">
					<div class="news-box">
						<div v-if="publishData && publishData.articleData">
							<div class="news-title">{{publishData.articleData.title}}</div>
							<div class="news-item" v-for="(item, index) in publishData.articleData.list" :key="index"
								@click="clickRoute(item)">
								{{ item.title }}
							</div>
						</div>
					</div>

					<div class="content-box">
						<!-- 排名：全国排名 / 省内排名 -->
						<div
							v-if="contentTypeList.length > 0
              && contentTypeList[activeContentType].value == 'rank'
              && (rankTypeList[activeRankType].value == 'nation_rank' || rankTypeList[activeRankType].value == 'province_rank')">
							<div class="rank-title">
								{{ rankTitle }}
							</div>
							<div class="data-table">
								<el-table :data="rankDataList" class="table" border stripe>
									<el-table-column prop="rank" label="排名" min-width="2"></el-table-column>
									<el-table-column prop="college.name" label="学校名称" min-width="6"></el-table-column>
									<el-table-column prop="college.province_name" label="省份" min-width="2"></el-table-column>
									<el-table-column prop="college.type" label="类型" min-width="2"></el-table-column>
									<el-table-column prop="examineName" label="分析内容" min-width="2"></el-table-column>
								</el-table>
								<div class="pagination">
									<pagination v-show="total>0" :total="total" :page.sync="params.page" limit.sync=20
										@pagination="loadContent" layout="prev, pager, next" />
								</div>

							</div>
						</div>

						<!-- 排名：省际比较 -->
						<div class="province_compare" v-if="contentTypeList.length > 0
              && contentTypeList[activeContentType].value == 'rank'
              && rankTypeList[activeRankType].value == 'province_compare'">
							<div class="left-tab-box">
								<div class="left-tab" v-for="(item, index) in compareList" :key="index"
									:class="{'active-left-tab': activeLeftTab == index}" @click="changeLeftTab(index)">
									{{ item.title }}
								</div>
							</div>
							<div class="right-content">
								<div class="top-tab-box">
									<div class="top-tab" v-for="(item, index) in topTabs" :key="index"
										:class="{'active-top-tab': activeTopTab == index}" @click="changeTopTab(index)">
										{{ item.title }}
									</div>
								</div>
								<div class="rank-title">
									{{ rankTitle }}
								</div>
								<!-- 省际排名-学校排名 -->
								<div class="data-table" v-if="topTabs[activeTopTab].value == 'college_rank'">
									<el-table :data="rankDataList" border stripe>
										<el-table-column prop="rank" label="排名" width="50"></el-table-column>
										<el-table-column prop="college.name" label="学校名称" width="240"></el-table-column>
										<el-table-column prop="college.province_name" label="省份"
											width="100"></el-table-column>
										<el-table-column prop="college.type" label="类型" width="60"></el-table-column>
										<el-table-column prop="examineName" label="分析内容" width="90"></el-table-column>
									</el-table>
									<pagination v-show="total>0" :total="total" :page.sync="params.page" limit.sync=20
										@pagination="loadContent" layout="prev, pager, next" />
								</div>
								<!-- 省际排名-学校统计 -->
								<div class="data-table" v-if="topTabs[activeTopTab].value == 'province_sts'">
									<el-table :data="rankDataList" border stripe>
										<el-table-column prop="rank" label="排名" width="100"></el-table-column>
										<el-table-column prop="province_name" label="省份" width="160"></el-table-column>
										<el-table-column prop="examineName" label="分析内容" width="200"></el-table-column>
										<el-table-column prop="num" label="数量" width="80"></el-table-column>
									</el-table>
								</div>

							</div>
						</div>

						<!-- 年报 -->
						<div class="repot-box" v-if="contentTypeList.length > 0
              && contentTypeList[activeContentType].value == 'report'">
							<el-scrollbar class="report-cnt-ctr">
								<div v-html="reportHtml"></div>
							</el-scrollbar>

							<div class="bt-box">
								<span class="download-bt" @click="openDownload">下载报告</span>
							</div>
						</div>
					</div>

<!-- 					<div class="content-right-ctr">
						<div v-if="publishData && publishData.templateData">
							<div class="news-title">{{publishData.templateData.title}}</div>
							<div class="news-item" v-for="(item, index) in publishData.templateData.list" :key="index"
								@click="clickRoute(item)">
								{{ item.name }}
							</div>
						</div>
					</div> -->

				</div>
			</div>
		</div>

		<el-dialog title="请输入您要下载的学校" :visible.sync="clgDlOpen" append-to-body align='center'>
			<el-form>
				<el-form-item :model="clgDlData" label="学校名字">
					<el-select v-model="collegeName" filterable remote reserve-keyword placeholder="请输入学校名字"
						:remote-method="loadColleges" @change="changeCollege">
						<el-option v-for="item in searchCollegeList" :key="item.id" :label="item.name" :value="item.id">
						</el-option>
					</el-select>
				</el-form-item>

				<el-form-item label="">
					<div>
						<span class="hot-text1">热门下载：</span>
						<span class="hot-text2" v-for="(item, index) in hotColleges" :key="index"
							@click="clickHot(item)">
							{{ item.name }}
						</span>
					</div>
				</el-form-item>

				<el-form-item label="" v-if="payData">
					<div>
						<span class="pay-title">支付方式：</span>
						<span class="pay-ctr" v-for="(item, index) in payData.list" :key="index"
							@click="clickPayMethod(index)">
							<span class="pay-item"
								:class="{'pay-item-selected': activePayIndex == index}">{{item.name}}</span>
						</span>
					</div>
				</el-form-item>

				<el-form-item label="" v-if="payData">
					<div class="pay-amount-ctr">
						<span class="pay-amount">{{payData.amount}}</span>
					</div>
				</el-form-item>
			</el-form>
			<div slot="footer" class="dialog-footer" align='center'>
				<el-button type="primary" @click="confirClgDownload">确 定</el-button>
				<el-button @click="cancelClgDownload">取 消</el-button>
			</div>
		</el-dialog>

		<el-dialog title="请输入您要下载的省份" :visible.sync="prnDlOpen" append-to-body align='center'>
			<el-form>
				<el-form-item :model="prnDlData" label="省份">
					<el-select v-model="prnDlData.province" placeholder="请选择" style="width: 100%;">
						<el-option v-for="item in provinceList" :key="item.value" :label="item.name"
							:value="item.value">
						</el-option>
					</el-select>
				</el-form-item>
				
				<el-form-item label="" v-if="payData">
					<div>
						<span class="pay-title">支付方式：</span>
						<span class="pay-ctr" v-for="(item, index) in payData.list" :key="index"
							@click="clickPayMethod(index)">
							<span class="pay-item"
								:class="{'pay-item-selected': activePayIndex == index}">{{item.name}}</span>
						</span>
					</div>
				</el-form-item>
				
				<el-form-item label="" v-if="payData">
					<div class="pay-amount-ctr">
						<span class="pay-amount">{{payData.amount}}</span>
					</div>
				</el-form-item>
			</el-form>
			<div slot="footer" class="dialog-footer" align='center'>
				<el-button type="primary" @click="confirPrnDownload">确 定</el-button>
				<el-button @click="cancelPrnDownload">取 消</el-button>
			</div>
		</el-dialog>
		
		<el-dialog title="微信支付" :visible.sync="showWxPay" append-to-body align='center' v-if="wxPayData"  @close="onWxPayDialogClosed">
		
			<div class="qr-ctr">
				<img :src="wxPayData.protocal" class="wx-pay-img"/>
				
				<img src="http://syzsoss.oss-cn-chengdu.aliyuncs.com/202509/12130236-90842874926238675.png" class="wx-pay-logo"/>
			</div>
		
			<div slot="footer" class="dialog-footer" align='center'>
				<el-button type="primary" @click="clickCloseWxDialog">已支付完成</el-button>
				<el-button @click="clickCloseWxDialog">取消支付</el-button>
			</div>
		</el-dialog>
		
		
		<el-dialog :title="clgRankData.title" :visible.sync="showClgRankDialog" append-to-body v-if="showClgRankDialog"
			align="center" width="80%">
			<div class="data-table">
				<div v-if="clgRankData.note" class="rank-dialog-note">{{clgRankData.note}}</div>
				<el-table :data="clgRankData.list" border v-else> 
					<el-table-column prop="year" label="年" align="center" min-width="5"></el-table-column>
					<el-table-column prop="rank_range" label="排名范围" align="center" min-width="8"></el-table-column>
					<el-table-column prop="quality_rank" label="培养质量排名" align="center" min-width="10"></el-table-column>
					<!-- <el-table-column prop="satisfy_rank" label="满意度排名" align="center" v-if="clgRankData.showSatisfy == 1" min-width="10"></el-table-column> -->
					<el-table-column prop="res_rank" label="教学资源排名" align="center" min-width="10"></el-table-column>
					<el-table-column prop="service_rank" label="服务贡献排名" align="center" min-width="10"></el-table-column>
					<el-table-column prop="effect_rank" label="国际影响排名" align="center" min-width="10"></el-table-column>
					<el-table-column prop="policy_rank" label="政策落实排名" align="center" min-width="10"></el-table-column>
					<el-table-column prop="score_rank" label="整体排名" align="center" min-width="8"></el-table-column>
				</el-table>
			</div>
			<div slot="footer" class="dialog-footer" align="center">
				<el-button type="primary" class="el-button--info" icon="el-icon-edit" @click="closeClgRankDialog()">关闭</el-button>
				<el-button type="primary" @click="clickClgReport()" icon="el-icon-message">查看年报详细数据</el-button>
			</div>
		</el-dialog>
		

	</div>
</template>

<script>
	import {
		getHeadData,
		getContent,
		getReportDownloadsPage,
		queryProvince,
		queryCollege,
		getPublishData,
		exportReport,
		prepareToDownload,
		toPay,
		queryCollegeRank
	} from "@/api/rank"

	import {
		isEmpty
	} from "@/utils/util"

	import {
		PayMethod
	} from "@/utils/const"

	import {
		parse,
		handleProtocal,
		handleRouteProtocal
	} from "@/utils/protocal"

	export default {
		name: "Rank",
		data() {
			return {
				levelList: [],
				activeLevel: 0,
				contentTypeList: [],
				activeContentType: 0,
				rankTypeList: [],
				activeRankType: 0,
				reportTypeList: [],
				activeReportType: 0,
				provinceList: [],
				searchProvinceList: [],
				searchCollegeList: [],
				activeProvince: 0,
				allPartList: [],
				activeAllPart: 0,
				partList: [],
				activePart: 0,
				yearList: [],
				activeYear: 0,
				newsList: [],

				rankTitle: undefined,
				rankDataList: [],
				total: 0,
				params: {
					page: 1
				},

				compareList: [{
						title: '前100名学校排名',
						value: 100
					},
					{
						title: '前200名学校排名',
						value: 200
					},
					{
						title: '前500名学校排名',
						value: 500
					},
					{
						title: '前1000名学校排名',
						value: 1000
					}
				],
				activeLeftTab: 0,
				topTabs: [{
						title: '学校排行',
						value: 'college_rank'
					},
					{
						title: '各省数量统计排名',
						value: 'province_sts'
					},
				],
				activeTopTab: 0,

				reportHtml: undefined,
				clgDlOpen: false,
				clgDlData: {},
				hotColleges: [],

				prnDlOpen: false,
				prnDlData: {},

				province_code: '',
				collegeId: '',
				collegeName: '',
				publishData: null,

				payData: null,
				activePayIndex: 0,
				wxPayData: null,
				showWxPay: false,
				
				showClgRankDialog: false,
				clgRankData: null
			}
		},
		created() {
			this.initPageData();
		},
		methods: {
			initPageData() {
				getHeadData().then(res => {
					this.levelList = res.data.contentMenu.levelList;
					this.contentTypeList = res.data.contentMenu.contentTypeList;
					this.reportTypeList = res.data.contentMenu.reportTypeList;
					this.provinceList = res.data.contentMenu.provinceList;
					this.rankTypeList = res.data.contentMenu.rankTypeList;
					this.allPartList = res.data.contentMenu.allPartList;
					this.partList = res.data.contentMenu.partList;
					this.yearList = res.data.contentMenu.yearList;
					this.initPassParams();
					this.refreshContent();
				});
				getPublishData().then(res => {
					this.publishData = res.data;
				});
			},


			loadContent() {
				getContent(this.params).then(res => {
					if (this.contentTypeList[this.activeContentType].value == 'rank') {
						this.rankTitle = res.data.title;
						this.rankDataList = res.data.list;
						this.total = res.data.pageData.totalCount;
					} else {
						this.reportHtml = res.data.template;
					}
				});
			},

			refreshContent() {
				this.prepareParams();
				this.loadContent();
			},

			initPassParams() {
				let params = this.$route.query
				console.log('initPassParams params', params)
				if (!isEmpty(params.content_type)) {
					this.activeContentType = this.findIndexByValue(this.contentTypeList, params.content_type, 'value')
				}

				if (!isEmpty(params.rank_type)) {
					this.activeRankType = this.findIndexByValue(this.rankTypeList, params.rank_type, 'value')
				}

				if (!isEmpty(params.all_part)) {
					this.activeAllPart = this.findIndexByValue(this.allPartList, params.all_part, 'value')
				}

				if (!isEmpty(params.part)) {
					this.activePart = this.findIndexByValue(this.partList, params.part, 'value')
				}
				
				if(params.showReportPay == 1){
					this.openDownload();	
					this.collegeId = params.college_id;
					this.collegeName = params.college_name;
				}
			},

			findIndexByValue(list, value, key) {
				let size = list.length;

				for (let i = 0; i < size; i++) {
					if (list[i][key] == value) {
						return i;
					}
				}

				return 0;
			},

			prepareParams() {
				this.params = {};
				this.params.level = this.levelList[this.activeLevel].value;
				this.params.content_type = this.contentTypeList[this.activeContentType].value;
				if (this.contentTypeList[this.activeContentType].value == 'rank') {
					// 排名参数
					this.params.rank_type = this.rankTypeList[this.activeRankType].value;
					if (this.rankTypeList[this.activeRankType].value == 'province_rank') {
						// 省内排名
						this.params.province_code = this.province_code;
					} else if (this.rankTypeList[this.activeRankType].value == 'province_compare') {
						// 省际比较
						this.params.chStsLimit = this.compareList[this.activeLeftTab].value;
						this.params.chTabType = this.topTabs[this.activeTopTab].value;
					}
				} else {
					// 年报参数
					this.params.report_type = this.reportTypeList[this.activeReportType].value;
				}
				this.params.all_part = this.allPartList[this.activeAllPart].value;
				if (this.allPartList[this.activeAllPart].value == 'part') {
					this.params.part = this.partList[this.activePart].value;
				}
				this.params.year = this.yearList[this.activeYear].value;
				this.params.page = 1;
			},

			changeLevel(index) {
				this.activeLevel = index;
				this.refreshContent();
			},

			changeContentType(index) {
				if (this.activeContentType == index) {
					return;
				}
				this.activeContentType = index;
				if (this.contentTypeList[this.activeContentType].value == 'rank') {
					this.activeReportType = 0;
				} else {
					this.activeRankType = 0;
				}
				this.refreshContent();
			},

			changeRankType(index) {
				this.activeRankType = index;

				if (this.rankTypeList[this.activeRankType].value != 'province_rank' ||
					(this.rankTypeList[this.activeRankType].value == 'province_rank' && !isEmpty(this.province_code))) {

					this.refreshContent();
				}

				if (this.rankTypeList[this.activeRankType].value == 'province_rank') {
					this.loadProvince('');
				}
			},

			changeReportType(index) {
				this.activeReportType = index;
				this.refreshContent();
			},

			changeProvince(index) {
				this.activeProvince = index;
				// this.province_code = index;
				this.refreshContent();
			},

			changeAllPart(index) {
				this.activeAllPart = index;
				this.refreshContent();
			},

			changePart(index) {
				this.activePart = index;
				this.refreshContent();
			},

			changeYear(index) {
				this.activeYear = index;
				this.refreshContent();
			},

			changeLeftTab(index) {
				this.activeLeftTab = index;
				this.refreshContent();
			},

			changeTopTab(index) {
				this.activeTopTab = index;
				this.refreshContent();
			},

			openDownload() {
				let level = this.levelList[this.activeLevel].value;
				let reportType = this.reportTypeList[this.activeReportType].value;
				
				if (reportType == 'college_report') {	
					console.log('this.clgRankData', this.clgRankData)
					if(this.clgRankData){
						this.collegeId = this.clgRankData.college.id;
						this.collegeName = this.clgRankData.college.name;
						this.clgRankData = null;
					}else{
						this.collegeId = ''
						this.collegeName = ''
					}

					console.log('this.collegeId', this.collegeId, 'this.collegeName', this.collegeName)
					getReportDownloadsPage({
						'level': level,
						'report_type': reportType
					}).then(res => {
						this.clgDlOpen = true;
						this.hotColleges = res.data.hot.list;
						this.payData = res.data.payData;
					});
				} else if (reportType == 'province_report') {								
					getReportDownloadsPage({
						'level': level,
						'report_type': reportType
					}).then(res => {
						this.prnDlOpen = true;
						this.payData = res.data.payData;
					});
				} else {
					// 直接下载
				}

			},

			clickPayMethod(index) {
				this.activePayIndex = index;
			},

			confirmQueryCollegeRank() {
				if (this.collegeId == '') {
					this.$modal.msgError('请输入学校名字');
					return;
				}

				let params = {
					college_id: this.collegeId,
				}
				
				queryCollegeRank(params).then(res => {
					this.clgRankData = res.data;
					this.showClgRankDialog = true;
				});
			},

			confirClgDownload() {
				if (this.collegeId == '') {
					this.$modal.msgError('请输入学校名字');
					return;
				}

				let params = {
					college_id: this.collegeId,
					report_type: this.params.report_type,
					year: this.params.year,
					part: this.params.part,
					pay_id: this.payData.list[this.activePayIndex]['id'],
					level: this.levelList[this.activeLevel]['name']
				}

				console.log('confirClgDownload params', params)
				
				if(this.payData.list[this.activePayIndex]['method'] == PayMethod['AliWebPay']){
					prepareToDownload(params).then(res => {
						console.log(res)
						let realData = res.data;
						let openUrl = realData.openUrl;
						console.log('openUrl', openUrl)
						if (openUrl != undefined && openUrl != '') {
							window.open(openUrl);
						}
					});
				}else{
					toPay(params).then(res => {
						console.log(res)
						this.clgDlOpen = false;
						this.prnDlOpen = false;
						let realData = res.data;
						let payData = realData.payData;
						console.log('payData', payData)
						this.handlePay(payData)
					});
				}
			},
						
			handlePay(payData){
				if (payData['method'] == PayMethod['WxWebPay']){
					this.handleWxWebPay(payData);
				}
			},
			
			handleWxWebPay(payData){
				this.showWxPay = true;
				this.wxPayData = payData;
			},

			cancelClgDownload() {
				this.clgDlOpen = false;
			},

			confirPrnDownload() {
				if (typeof this.prnDlData.province == 'undefined' || this.prnDlData.province == '') {
					this.$modal.msgError('请选择省份');
				}
				
				let params = {
					province_code: this.prnDlData.province,
					report_type: this.params.report_type,
					year: this.params.year,
					part: this.params.part,
					pay_id: this.payData.list[this.activePayIndex]['id'],
					level: this.levelList[this.activeLevel]['name']
				}
				
				console.log('confirClgDownload params', this.prnDlData.province)
				prepareToDownload(params).then(res => {
					console.log(res)
					let realData = res.data;
					let openUrl = realData.openUrl;
					console.log('openUrl', openUrl)
					if (openUrl != undefined && openUrl != '') {
						window.open(openUrl);
					}
				});
				
			},

			cancelPrnDownload() {
				this.prnDlOpen = false;
			},

			loadProvince(province_name) {
				queryProvince({
					name: province_name
				}).then(res => {
					this.searchProvinceList = res.data.list;
					this.province_code = this.searchProvinceList[0]['province_code']
					this.refreshContent();
				});
			},

			loadColleges(collegeName) {
				let level = this.levelList[this.activeLevel].value;
				queryCollege({
					name: collegeName,
					year: this.params.year,
					level: level
				}).then(res => {
					this.searchCollegeList = res.data.list;
				});
			},
			
			loadRankColleges(collegeName) {
				let level = this.levelList[this.activeLevel].value;
				queryCollege({
					name: collegeName,
					level: level
				}).then(res => {
					this.searchCollegeList = res.data.list;
				});
			},

			changeCollege(value) {
				console.log('changeCollege value', value)
				this.collegeId = value;
			},

			clickHot(item) {
				this.collegeId = item.id;
				this.collegeName = item.name
			},

			clickRoute(item) {
				console.log('item', item)
				let data = parse(item.url)

				if (data['head'] == 'replace') {
					let url = "/" + data['path'];
					if (data['data'] != null && data['data'].length != 0) {
						url += "?" + data['data'];
					}
					console.log('url', url)
					// this.$router.replace(url);
					this.$router.push(url);
				} else {
					handleRouteProtocal(data)
				}
			},
			
			clickCloseWxDialog(){
				this.showWxPay = false;
				this.onWxPayDialogClosed();
			},
			
			onWxPayDialogClosed(){
				let out_trade_no = this.wxPayData['out_trade_no'];
				
				let path = '/authRedirect?out_trade_no=' + out_trade_no
				this.$router.push(path);
			},
			
			closeClgRankDialog() {
				this.showClgRankDialog = false;
			},
			
			clickClgReport(){
				this.closeClgRankDialog();
				this.changeContentType(1)
			}
		}
	}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
	@use "rank.scss";
</style>